/* eslint-disable import/prefer-default-export */
export const paramsFilter = ({ params }) => {
  if (params) {
    const query = {
      offset: params?.offset || 0,
      limit: params?.limit,
      search: params?.searchArray
        ? params?.searchArray
        : [{ selector: params?.searchSelector, keyword: params?.keyword }],
      sort: { selector: params?.selector, order: params?.order },
      searchOperator: params?.searchOperator,
    };

    if (!params?.searchArray && !params?.searchSelector) {
      delete query?.search;
      delete query?.searchOperator;
    }

    if (params?.keyword === '' || params?.keyword === undefined) {
      delete query?.search;
    }

    if (params?.searchArray) {
      if (params?.searchArray?.length === 0) {
        delete query.search;
        delete query.searchOperator;
      }
      if (params?.searchArray?.length > 0) {
        query.search = params.searchArray.filter((item) => {
          return item?.keyword !== '' && item?.keyword !== undefined;
        });
      }
    }

    if (
      params?.selector === undefined ||
      params?.selector === '' ||
      params?.order === undefined ||
      params?.order === ''
    ) {
      delete query.sort;
    }

    if (query.searchSelector === undefined) {
      delete query.searchSelector;
    }

    if (query?.searchOperator === undefined) {
      delete query?.searchOperator;
    }

    if (Object.prototype.hasOwnProperty.call(query, 'search')) {
      query.search = JSON.stringify(query.search);
    }

    return query;
  }
  return '';
};
